<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
      <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;">
        <v-container class="site-padding" id="aboutActionSection">
          <v-layout row wrap class="doctors-container">
            <v-flex xs12 class="text-xs-left">
              <h1 class="my-header doctors-container--header pt-4">Regulamin IV Forum Jaskry</h1>
              <div class="sparator-container pt-4">
                <div class="sparator-rectangle"></div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-text doctors-container">
            <v-flex xs12 class="text-xs-left">
              <span class="doctors-container--sections">Digital Knowledge Village ul. Puławska 457, 02-844 Warszawa</span>
            </v-flex>
            <v-flex xs12 class="text-xs-left">
              <span class="doctors-container--sections text-uppercase">I. Postanowienia ogólne</span>
              <div class="pb-3">
                <ol>
                  <li>III&nbsp;Polskie Forum Jaskry zwane w&nbsp;dalszej części regulaminu „Forum”, odbędzie się w&nbsp;dniu 7 marca 2020 r. w&nbsp;Digital Knowledge Villageprzy ul. Puławskiej 457,02-844 Warszawa</li>
                  <li>Forum obsługuje firma LPT Group Sp. z&nbsp;o.o. z&nbsp;siedzibą w&nbsp;Łodzi przy ul. Gdańskiej 126/128, NIP 7282740006 zwana w&nbsp;dalszej części Biurem Organizacyjnym Forum, działająca na zlecenie Polskiego Towarzystwa Okulistycznego z&nbsp;siedzibą przy ul.&nbsp;Czerniakowskiej&nbsp;231 w&nbsp;Warszawie.</li>
                  <li>Przepisy niniejszego Regulaminu stanowią integralną część Zgłoszenia uczestnictwa w&nbsp;Forum i&nbsp;obowiązują wszystkich Uczestników.</li>
                  <li>Uczestnikami Forum są lekarze okuliści, rezydenci, studenci oraz inne osoby związane zawodowo z&nbsp;tematyką Forum.</li>
                  <li>Forum odbędzie się w&nbsp;konwencji warsztatu hybrydowego czyli warsztatu składającego się  zarówno z&nbsp;widowni online jak i&nbsp;widowni na miejscu.</li>
                  <li>Oficialny serwis internetowy Forum znajduje się pod adresem: <router-link :to="{ name: 'Homepage' }" class="doctors-container--links">www.tydzienjaskry.pl</router-link></li>
                  <li>Koszt udziału w Forum to 100zł brutto dla wszystkich uczestników. Organizator nie pokrywa kosztów przejazdu, każdy Uczestnik pokrywa go we własnym zakresie.</li>
                </ol>
              </div>
              <span class="doctors-container--sections text-uppercase">II. Zasady uczestnictwa i&nbsp;odwołania uczestnictwa w&nbsp;Forum </span>
              <div class="pb-3">
                <ol>
                  <li>Warunkiem udziału w&nbsp;Forum jest zgłoszenie uczestnictwa w nim poprzez wypełnienie formularza zgłoszeniowego dostępnego na stronie internetowej Forum <router-link :to="{ name: 'ForumRegister' }" class="doctors-container--links">www.tydzienjaskry.pl/forum-jaskry/rejestracja</router-link>oraz pokonaniu opłaty.</li>
                  <li>Termin nadsyłania zgłoszeń uczestnictwa w Forum za pośrednictwem serwisu internetowego
                  <router-link :to="{ name: 'ForumRegister' }" class="doctors-container--links">www.tydzienjaskry.pl/forum-jaskry/rejestracja</router-link>
                    upływa 28 lutego 2020 r.  Rejestracja po tym terminie będzie możliwa jedynie osobiście w recepcji Forum.</li>
                  <li>Biuro Organizacyjne Forum zastrzega sobie prawo do ustalenia maksymalnej liczby Uczestników oraz wcześniejszego zakończenia rejestracji.</li>
                  <li>Uczestnik może zrezygnować z&nbsp;uczestnictwa w&nbsp;Forum. Rezygnacja Uczestnika z&nbsp;udziału w&nbsp;Forum winna być dokonana w&nbsp;formie elektronicznej na adres: <a href="mailto:tydzienjaskry@pto.com.pl" class="doctors-container--links">tydzienjaskry@pto.com.pl</a></li>
                </ol>
              </div>
              <span class="doctors-container--sections text-uppercase">III. Postanowienia końcowe</span>
              <div class="pb-3">
                <ol>
                  <li>
                    W przypadku, gdy Forum nie odbędzie się z&nbsp;przyczyn niezależnych od Biura Organizacyjnego Forum, Uczestnikowi nie przysługuje prawo do odszkodowania, a jedynie zwrot opłaty rejestracyjnej w Forum.
                  </li>
                  <li>Wszelkie spory mogące wyniknąć z&nbsp;tytułu uczestnictwa w&nbsp;Forum będą rozstrzygane przez sąd właściwy dla siedziby Biura Organizacyjnego Forum.</li>
                  <li>Zgłoszenie uczestnictwa w&nbsp;Forum oznacza akceptację postanowień niniejszego Regulaminu, a&nbsp;także przestrzegania przepisów porządkowych oraz wszelkich innych ustaleń dokonanych między Uczestnikiem a&nbsp;Biurem Organizacyjnym Forum.</li>
                  <li>W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy Kodeksu cywilnego.</li>
                  <li>Forum ma charakter zamknięty i&nbsp;nie stanowi imprezy masowej w&nbsp;rozumieniu Ustawy z&nbsp;dnia 23.03.2009&nbsp;r. o&nbsp;bezpieczeństwie imprez masowych (Dz. U.&nbsp;2009 nr 62 poz. 504).</li>
                  <li>Biuro Organizacyjne Forum nie ponosi odpowiedzialności za rzeczy Uczestników, które mogą zostać zgubione, zniszczone lub skradzione podczas Forum.</li>
                  <li>Uczestnicy ponoszą pełną odpowiedzialność materialną za dokonane przez siebie zniszczenia zarówno na terenie obiektów, w&nbsp;których prowadzone są jakiekolwiek działania związane z&nbsp;Forum.</li>
                  <li>Niniejszy regulamin wchodzi w&nbsp;życie z&nbsp;dniem jego zamieszczenia na stronie internetowej <router-link :to="{ name: 'Homepage' }" class="doctors-container--links">www.tydzienjaskry.pl</router-link></li>
                  <li>
                    Biuro Organizacyjne Forum ma prawo zmiany postanowień regulaminu. Zmiany wchodzą w&nbsp;życie w&nbsp;terminie 7&nbsp;dni od dnia ich zamieszczenia na stronie internetowej
                    <router-link :to="{ name: 'Homepage' }" class="doctors-container--links">www.tydzienjaskry.pl</router-link>
                  </li>
                </ol>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div class="header-separator" style="height: 50px;"></div>
  </div>
</template>

<script>
import DoctorHeader from '@/components/partials/DoctorHeader';

export default {
  data() {
    return {};
  },
  components: {
    DoctorHeader,
  },
  beforeMount() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.doctors-container--header {
  color: rgb(164, 22, 17);
}
.doctors-container--links {
  color: #a41611;
  font-family: 'Fira Sans', sans-serif;
}
.doctors-container--sections {
  color: #275271;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.doctors-container--sections-brown {
  color: #a41611;
}
.doctors-container--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}
.doctors-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  line-height: 120px;
  border: none;
  padding: 20px;
}
.doctors-container--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.register-bg {
  position: relative;
}
.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: '';
  position: fixed;
  opacity: 0.1;
  background-image: url('./../assets/images/register-bg.png');
  background-repeat: repeat;
  background-position: center center;
}
.doctor-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.main-header--free {
  width: 280px;
}
.button-container-blue {
  background: #275271;
  opacity: 0.9;
  cursor: pointer;
}
.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
  cursor: pointer;
}
.button-container--register {
  font-family: 'Fira Sans', sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.doctor-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}
.button-container--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.button-container--arrow {
  margin-right: 20px
}
.free-main-header--margin {
  margin-top: 100px;
}
.button-container--margin {
  margin-bottom: 30px;
}
.button-container--padding {
  padding-top: 50px!important;
  padding-bottom: 50px!important;
}
.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}
.videoWrapper {
    position: relative;
    width: 95%;
    left: 5%;
    top: 3%;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}
.doctors-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
}
.doctors-container--download-text {
    display: flex;
    vertical-align: middle;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-start;
    padding-left: 15px;
}
@media only screen and (max-width: 600px) {
  .button-container--arrow {
    width: 20px;
    margin-right: 5px
  }
  .button-container--text {
    font-size: 26px;
  }
}
.register-form--noShadow {
  -webkit-box-shadow: none!important;
  box-shadow: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ForumRegulations.vue